import _ from "lodash";
/**
 * @ngdoc Controller
 * @name ProfileNotificationsController
 */
(function() {
    "use strict";

    angular
        .module("vrm.core")
        .controller(
            "ProfileNotificationsController",
            ProfileNotificationsController
        )
        .constant("NOTIFICATION_CHANNELS", {
            email: "1",
            desktop: "2",
            mobile: "3",
            whatsapp: "4"
        });

    /**
     * @constructor
     * @ngInject
     */
    function ProfileNotificationsController(
        locale,
        $log,
        $scope,
        $rootScope,
        UserService,
        ApiService,
        $q,
        NotificationsService,
        NOTIFICATION_CHANNELS,
        localStorageService,
        vrmNotificationsService,
        vrmNotificationType,
        VrmModalService,
        $timeout
    ) {
        $log.info("ProfileNotificationsController");
        $scope.mobileView = NotificationsService.checkMobileWrapper();
        $scope.user = null;

        $scope.loading = {
            desktop: false,
            mobile: false,
            whatsapp: false,
            email: false
        };

        $scope.notificationsOptions = [];
        $scope.notificationsTypes = {
            email: {},
            desktop: {},
            mobile: {}
        };
        $scope.otherNotificationDevices = [];

        $scope.areThereOtherDevices = function areThereOtherDevices() {
            return $scope.otherNotificationDevices.length !== 0;
        };

        $scope.setLoadingFlag = function setLoadingFlag(value, channel = null) {
            if (!channel)
                Object.keys(NOTIFICATION_CHANNELS).forEach(
                    keyChannel => ($scope.loading[keyChannel] = value)
                );
            else {
                $scope.loading[channel] = value;
            }
        };

        $scope.setLoadingFlag(true);

        if (!$scope.user) {
            UserService.getUser().then(function(user) {
                $scope.user = user;
                getActiveChannels();
            });
        }

        const isEmail = item =>
            item.idNotificationChannel == NOTIFICATION_CHANNELS["email"];

        $scope.remove = function remove(device) {
            NotificationsService.unsubscribeDeviceFromChannel(
                $scope.user.id,
                device.idBinding
            )
                .then(() => {
                    locale.ready("notifications").then(function() {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString(
                                "notifications.device_removed_notification"
                            )
                        });
                    });
                    $scope.otherNotificationDevices = _.reject(
                        $scope.otherNotificationDevices,
                        item => {
                            return item.idBinding === device.idBinding;
                        }
                    );
                })
                .catch(error => {
                    $log.error(error);
                });
        };

        $scope.sendTestNotification = function sendTestNotification() {
            ApiService.call(
                "/users/" + $scope.user.id + "/test-notifications",
                null,
                "GET"
            )
                .then(() => {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.SUCCESS,
                        message: locale.getString(
                            "notifications.sent_notifications"
                        )
                    });
                })
                .catch(() => {
                    $log.error(error);
                    locale.ready("notifications").then(function() {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.ERROR,
                            message: locale.getString(
                                "notifications.failed_to_send_test"
                            )
                        });
                    });
                });
        };

        async function getActiveChannels() {
            $scope.notificationsTypes.email = {
                deviceName: $scope.user.email,
                isActive: false
            };
            $scope.notificationsTypes.desktop = $scope.notificationsTypes.mobile = {
                isActive: false,
                deviceName: NotificationsService.getDeviceName()
            };
            const deviceToken = await NotificationsService.getDeviceToken();
            return NotificationsService.getNotificationChannels(
                $scope.user.id,
                deviceToken ? { deviceToken } : {}
            ).then(function(response) {
                const { data: activeChannels } = response.data;
                $scope.notificationsOptions = activeChannels;
                $scope.notificationsOptions.other = Object.values($scope.notificationsOptions.other);
                if (activeChannels.current !== null) {
                    $scope.notificationsTypes.desktop = $scope.notificationsTypes.mobile = {
                        ...activeChannels.current,
                        isActive: true,
                        deviceName: NotificationsService.getDeviceName(),
                    };
                }

                $scope.notificationsOptions.other.forEach((item, idx) => {
                    if (isEmail(item)) {
                        $scope.notificationsOptions.other[idx].deviceName =
                            $scope.user.email;
                        $scope.notificationsTypes.email = {
                            ...item,
                            isActive: true
                        };
                    }
                });
                $scope.notificationsOptions.other = _.sortBy(
                    $scope.notificationsOptions.other,
                    ["idNotificationChannel", "deviceName"]
                );
                $scope.otherNotificationDevices = $scope.notificationsOptions.other.filter(
                    item => !isEmail(item)
                );
                $scope.setLoadingFlag(false);
            });
        }

        const cleanUpNotificationUpdate = $rootScope.$on(
            "notification-update",
            function(_event, type) {
                console.log(" update ", type);
                switch (type) {
                    case NOTIFICATION_CHANNELS.mobile:
                        $scope.loading.mobile = false;
                        break;
                    case NOTIFICATION_CHANNELS.desktop:
                        $scope.loading.desktop = false;
                        break;
                }
                getActiveChannels();
            }
        );

        const cleanUpForceNotificationUpdate = $rootScope.$on(
            "notification-force-update",
            function(_event) {
                console.log(" force update ");
                getActiveChannels();
            }
        );

        const cleanUpNotificationLoading = $rootScope.$on(
            "notification-loading",
            function(_event, type) {
                console.log(" loading ", type);
                switch (type) {
                    case NOTIFICATION_CHANNELS.mobile:
                        $scope.loading.mobile = true;
                        break;
                    case NOTIFICATION_CHANNELS.desktop:
                        $scope.loading.desktop = true;
                        break;
                }
            }
        );

        $scope.$on("$destroy", () => {
            cleanUpNotificationLoading();
            cleanUpNotificationUpdate();
            cleanUpForceNotificationUpdate();
        });

        $scope.toggleEmail = () => {
            $scope.loading.email = true;
            const newToggleValue = !$scope.notificationsTypes.email.isActive;
            $scope.saveChannel(
                NOTIFICATION_CHANNELS.email,
                newToggleValue,
                $scope.notificationsTypes.email
            );
        };

        $scope.toggleDesktop = () => {
            $scope.loading.desktop = true;
            const newToggleValue = !$scope.notificationsTypes.desktop.isActive;
            if (!newToggleValue) {
                $scope.saveChannel(
                    NOTIFICATION_CHANNELS.desktop,
                    newToggleValue,
                    $scope.notificationsTypes.desktop
                );
            } else {
                NotificationsService.processPushNotificationsRequest()
                    .then(function() {
                        $scope.saveChannel(
                            NOTIFICATION_CHANNELS.desktop,
                            newToggleValue,
                            $scope.notificationsTypes.desktop
                        );
                    })
                    .catch(function(error) {
                        $log.error(error);
                        $scope.channels.desktop = false;
                        $scope.$apply();
                    });
            }
        };

        $scope.toggleMobile = () => {
            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.handleNotificationToggleClicked
            ) {
                window.webkit.messageHandlers.handleNotificationToggleClicked.postMessage(
                    {}
                );
            }

            if (
                window.Android &&
                window.Android.handleNotificationToggleClicked
            ) {
                window.Android.handleNotificationToggleClicked();
            }
        };

        $scope.saveChannel = async function saveChannel(
            channel,
            isActive,
            item
        ) {
            const deviceToken = await NotificationsService.getDeviceToken();
            if (channel == NOTIFICATION_CHANNELS.mobile && !!deviceToken) {
                NotificationsService.askPermission();
                return;
            }

            let meta = {};
            if (channel != NOTIFICATION_CHANNELS.email) {
                meta = {
                    deviceToken,
                    deviceName: NotificationsService.getDeviceName(),
                    tokenType: NotificationsService.getTokenType(),
                };
            }
            const type = Object.keys(NOTIFICATION_CHANNELS).find(
                key => NOTIFICATION_CHANNELS[key] === channel
            );

            if (isActive) {
                NotificationsService.handleSubscriptionToChannel(
                    channel,
                    $scope.user.id,
                    meta
                )
                    .then(function({ data }) {
                        $timeout(function() {
                            if (type === NOTIFICATION_CHANNELS.email) {
                                localStorageService.set(`CURRENT_ID_TOKEN-${$scope.user.id}`, data.data.idBinding);
                            }
                            $scope.setLoadingFlag(false, type);
                            $scope.notificationsTypes[type] = { ...$scope.notificationsTypes[type], ...data.data, isActive: true }
                            $scope.$apply();
                        })
                    })
                    .catch(function(err) {
                        $timeout(function() {
                            $scope.setLoadingFlag(false, type);
                            $log.error(err);
                        })
                    });
            } else {
                NotificationsService.unsubscribeDeviceFromChannel(
                    $scope.user.id,
                    item.idBinding
                ).then(function() {
                    $timeout(function() {
                        $scope.notificationsTypes[type].isActive = false;
                    })
                }).finally(() => {
                    $timeout(function() {
                        $scope.setLoadingFlag(false, type);
                    })
                });
            }
        };
    }
})();
